import { Drawer } from 'antd'
import React, { useState, useEffect, useMemo } from 'react'
import { Egg } from './__egg__'

const createKeyChecker = (hotkeys = []): (key: string) => boolean => {
  let index = 0
  const TAIL = hotkeys.length - 1

  return (key) => {
    if (key !== hotkeys[index]) {
      index = 0
      return false
    }

    if (index === TAIL) {
      index = 0
      return true
    }

    index++
    return false
  }
}

const useEggs = (
  onMatch: () => void
): void => {
  const konami = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a'
  ]
  const keyCrawler = useMemo(() => createKeyChecker([].concat(konami)), [konami])

  const onKeyPress = ({ key }): void => {
    if (keyCrawler(key)) {
      onMatch()
    }
  }

  useEffect(() => {
    window?.addEventListener('keydown', onKeyPress)
    return () => window?.removeEventListener('keydown', onKeyPress)
  })
}

const Spacer: React.FC<{ height: number }> = ({ height }): JSX.Element => {
  const [visible, setVisible] = useState<boolean>(false)
  const toggleEgg = (): void => setVisible(!visible)

  useEggs(() => toggleEgg())

  return (
    <div style={{ height }}>
      <Drawer
        onClose={toggleEgg}
        bodyStyle={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center'
        }}
        height={'fit-content'}
        style={{ zIndex: 99 }}
        placement='bottom'
        getContainer={'header-app-root'}
        {...{ visible }}
      >
        <Egg />
      </Drawer>
    </div>
  )
}

export default Spacer
